export default __webpack_public_path__ + "a5a74f3a9b67b3cd425200647f7d2470.png";